var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{attrs:{"msg":"Welcome to Dashboard ( Home )"}})
}
var staticRenderFns = []

export { render, staticRenderFns }